"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.getCaptchaTokenV2 = getCaptchaTokenV2;
exports.GOOGLE_RECAPTCHA_ERROR = exports.GOOGLE_RECAPTCHA_EXPIRED = exports.GOOGLE_RECAPTCHA_INIT_ERROR = exports.RECAPTCHA_ELEMENT_ID = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _utils = require("./utils");

var RECAPTCHA_ELEMENT_ID = 'Webmail_recaptcha';
exports.RECAPTCHA_ELEMENT_ID = RECAPTCHA_ELEMENT_ID;
var GOOGLE_RECAPTCHA_INIT_ERROR = 'Error in initialzing Google reCAPTCHA';
exports.GOOGLE_RECAPTCHA_INIT_ERROR = GOOGLE_RECAPTCHA_INIT_ERROR;
var GOOGLE_RECAPTCHA_EXPIRED = 'The result of reCAPTCHA challenge is expired. Please try again.';
exports.GOOGLE_RECAPTCHA_EXPIRED = GOOGLE_RECAPTCHA_EXPIRED;
var GOOGLE_RECAPTCHA_ERROR = 'Error in submitting the result of reCAPTCHA challenge. Please check your network connection and try again later.';
exports.GOOGLE_RECAPTCHA_ERROR = GOOGLE_RECAPTCHA_ERROR;

function getCaptchaElement() {
  var element = document.createElement('div');
  element.id = "".concat(RECAPTCHA_ELEMENT_ID, "-").concat((0, _moment["default"])().unix().toString(16));
  document.getElementById(RECAPTCHA_ELEMENT_ID).appendChild(element);
  return element;
}

function toggleCaptchaBadge() {
  var captcha = document.querySelector('.grecaptcha-badge');

  if (captcha) {
    captcha.style.setProperty('visibility', captcha.style.visibility ? '' : 'hidden');
  }
}

function initialReCaptcha() {
  // Reference
  // https://github.com/dozoisch/react-google-recaptcha/pull/73/commits/e8819437887facec1bf9d3f884cb329adc39f62a
  function reset() {
    var container = document.getElementById(RECAPTCHA_ELEMENT_ID);

    if (container) {
      // Remove the rendered badge
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    } else {
      // Create append the container
      container = document.createElement('div');
      container.id = RECAPTCHA_ELEMENT_ID;
      document.body && document.body.appendChild(container);
    }
  }

  return new Promise(function (resolve, reject) {
    Promise.resolve(reset()).then(function () {
      return (0, _utils.applyScript)(_utils.RECAPTCHA_GOOGLE_API);
    }).then(function () {
      var recaptcha = window.grecaptcha;
      recaptcha.ready(function () {
        resolve(recaptcha);
      });
    })["catch"](function (e) {
      console.error(e);
      reject(new Error(GOOGLE_RECAPTCHA_INIT_ERROR));
    });
  });
}
/**
 * Google OAuth handler
 *
 * @public
 * @returns {Promise<GoogleOAuthResponse>}
 */


function _default(action) {
  toggleCaptchaBadge();
  return new Promise(function (resolve, reject) {
    initialReCaptcha().then(function (recaptcha) {
      recaptcha.execute(_utils.RECAPTCHA_GOOGLE_CLIENT_ID, {
        action: action
      }).then(function (token) {
        resolve({
          token: token
        });
        setTimeout(toggleCaptchaBadge);
      });
    });
  });
}

function getCaptchaTokenV2() {
  return new Promise(function (resolve, reject) {
    initialReCaptcha().then(function (recaptcha) {
      try {
        recaptcha.render(getCaptchaElement(), {
          tabindex: -1,
          size: 'invisible',
          sitekey: _utils.RECAPTCHA_GOOGLE_CLIENT_ID_V2,
          'error-callback': function errorCallback() {
            return reject(new Error(GOOGLE_RECAPTCHA_ERROR));
          },
          'expired-callback': function expiredCallback() {
            return reject(new Error(GOOGLE_RECAPTCHA_EXPIRED));
          },
          callback: function callback(token) {
            resolve({
              token: token
            });
          }
        });
        recaptcha.execute();
      } catch (e) {
        reject(e);
      }
    });
  });
}
//# sourceMappingURL=captcha.js.map